<template>
  <PersonalLayout>
    <template v-slot:header>
      <AppHeader />
    </template>
    <template v-slot:side>
      <router-link to="/personal-objects" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 7L12 3L4 7M20 7L12 11M20 7V17L12 21M12 11L4 7M12 11V21M4 7V17L12 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Мои объекты') }}</span>
      </router-link>
      <router-link to="/my-fonts" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 7V4H20V7M9 20H15M12 4V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Мои шрифты') }}</span>
      </router-link>
      <router-link to="/my-processings" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('ИИ обработки') }}</span>
      </router-link>
      <router-link to="/personal-subscription" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M21 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 10H23" stroke="currentColor" stroke-width="2"/></svg>
        <span>{{ $t('Подписка') }}</span>
      </router-link>
      <router-link to="/personal-account" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Аккаунт') }}</span>
      </router-link>
      <div class="side-slide active">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Безопасность') }}</span>
      </div>
      <router-link v-if="isAdmin" to="/admin" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Панель администратора') }}</span>
      </router-link>
      <div class="side-slide logout-slide" @click="handleLogout">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><polyline points="16,17 21,12 16,7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Выйти') }}</span>
      </div>
    </template>
    <template v-slot:content>
      <div class="content-block">
          <div class="content-block__label">{{ $t('Измените пароль') }}</div>
          <form action="" class="password-change-form" @submit.prevent="handleSubmit">
            <AppInput v-model="newPassword" type="password" :label="$t('Новый пароль')" :placeholder="$t('Пароль')" />
            <AppInput v-model="verifiedPassword" type="password" :label="$t('Подтвердите новый пароль')" :placeholder="$t('Пароль')" />
            <div class="password-change-form__action">
              <AppButton :label="$t('Сохранить')" type="submit" />
              <AppButton :label="$t('Сбросить')" type="reset" variant="grey" @click="resetForm" />
            </div>
          </form>
        </div>
    </template>
  </PersonalLayout>
</template>

<script>
import PersonalLayout from '@/layout/PersonalLayout.vue';
import AppHeader from '@/components/AppHeader.vue';
import AppButton from '@/components/ui/AppButton.vue';
import AppInput from '@/components/ui/AppInput.vue';
import { useToast } from 'vue-toastification';

export default {
  name: 'ProfileSecurity',
  components: {
    PersonalLayout,
    AppHeader,
    AppButton,
    AppInput,
  },

  data() {
    return {
      toast: useToast(),
      newPassword: '',
      verifiedPassword: '',
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters['subscription/isAdmin'];
    },
  },
  methods: {
    async handleLogout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    async handleSubmit() {
      if (this.newPassword !== this.verifiedPassword) {
        this.toast.error(this.$t('Пароли не совпадают'));
        return;
      }

      if (this.newPassword.length < 8) {
        this.toast.error(this.$t('Пароль должен содержать минимум 6 символов'));
        return;
      }

      const formData = new FormData();
      formData.append('new_password', this.newPassword);

      const response = await this.$store.dispatch('auth/updatePassword', formData);

      if (!response.success) {
        this.toast.error(response.result.message);
      } else {
        this.toast.success(this.$t('Данные успешно обновлены'));
      }
    },
    resetForm() {
      this.newPassword = '';
      this.verifiedPassword = '';
    },
  },
};
</script>

<style scoped>
.side-slide {
  display: block;
  padding: 10px;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  color: #1a1a1a;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 5px;
  border: 1px solid transparent;
  text-decoration: none;
}

.side-slide p {
  margin: 0;
  color: inherit;
}

.side-slide a {
  color: inherit;
}

.side-slide.active {
  border-color: #fafafa;
  box-shadow: inset 1px 1px 2px 0 rgba(0, 0, 0, 0.09);
  color: #1a1a1a;
}

.side-slide + .side-slide {
  margin-top: 5px;
}

.input-wrapper + .input-wrapper {
  margin-top: 30px;
}

/* Основные стили */
.content-block {
  width: 100%;
  background-color: white;
  border: 1px solid #fafafa;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 3px 3px 4px 0 rgba(178, 176, 173, 0.2);
}

.spinner {
  width: 24px;
  height: 24px;
  animation: rotate 2s linear infinite;
}

.spinner .path {
  stroke: #0066ff;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

/* Адаптивные стили */
@media (max-width: 768px) {
  .content-block {
    width: calc(100% - 24px);
    border: none;
    margin: 0 12px;
    padding: 20px 16px;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  }
  
  .content-block__label {
    font-size: 18px;
    margin-bottom: 16px;
  }
  
  .password-change-form {
    max-width: 100%;
  }
  
  .password-change-form__action {
    margin-top: 16px;
    gap: 8px 12px;
  }
  
  .password-change-form__action :deep(.app-button) {
    padding: 10px 16px;
    font-size: 13px;
  }
}

/* Дополнительные стили */
.content-block__label {
  font-weight: 400;
  font-size: 20px;
  line-height: 120%;
  color: #1a1a1a;
  margin-bottom: 30px;
}

.password-change-form {
  max-width: 470px;
}

.password-change-form__action {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 30px;
  margin-top: 30px;
}
</style>
